import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Announcement from "./sections/Announcement";
import BuiltOnHardWorkDrivenByResults from "./sections/BuiltOnHardWorkDrivenByResults";
import PulseOfTheNetwork from "./sections/PulseOfTheNetwork";
import TheCrewProcess from "./sections/TheCrewProcess";
import UnifiedExperience from "./sections/UnifiedExperience";
import VoicesOfSuccess from "./sections/VoicesOfSuccess";
import JoinTheMovement from "./sections/JoinTheMovement";
import MainSiteFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <Announcement />
      <BuiltOnHardWorkDrivenByResults />
      <PulseOfTheNetwork />
      <TheCrewProcess />
      <UnifiedExperience />
      <VoicesOfSuccess />
      <JoinTheMovement />
      <MainSiteFooter />
    </div>;
}